(function () {
    'use strict';
    var controllerId = 'accrAnnulled';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'accreditamento', accrAnnulled]);

    function accrAnnulled($scope, datacontext, $uibModalInstance, accreditamento) {
        $scope.accreditamento = jQuery.extend({}, accreditamento); //Clona oggetto
        $scope.nominativo = $scope.accreditamento.L_CodiceFiscale;

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.accreditamento);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.cndAccreditamento_setAnnulled(item.Id, true, $scope.noteAnnulled).then(function (data) {
                return data;
            });
        }

    }
})();